import { createFileRoute } from '@tanstack/react-router';
import { formStepsSearchSchema } from '@/components/form/FormStepsPage';
import { BankReconciliationCreationPage } from '@/features/bank-reconciliations/components/BankReconciliationCreationPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/bank-reconciliations/creation')({
  component: BankReconciliationCreationPage,
  validateSearch: formStepsSearchSchema,
});
